module.exports = __webpack_public_path__ + "static/media/emptyPaper.ffa57e55.png";